import React from 'react';
import { withStyles } from '@material-ui/core/styles';

const OverflowContainer = ({ children, className = '', x = 'auto', y = 'auto', style = {}, classes, ...props }) => {
  const containerClass = `${classes.container} ${className}`.trim();
  const containerStyle = { ...style, overflowX: x, overflowY: y };
  return (
    <div className={containerClass} style={containerStyle} {...props}>
      {children}
    </div>
  );
};

const styles = theme => ({
  container: {
    height: '100%',
    flexGrow: 1
  }
});

export default withStyles(styles)(OverflowContainer);
